<template>
  <div class="car-month-card-config-container">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>{{ $t('carMonthCardConfig.title') }}</span>
        <div style="float: right;">
          <el-button type="primary" size="mini" icon="el-icon-plus" @click="showAddDialog()">
            {{ $t('carMonthCardConfig.add') }}
          </el-button>
        </div>
      </div>

      <el-alert :title="$t('carMonthCardConfig.tips.communityScope')" type="info" :closable="false" show-icon />

      <!-- 查询条件 -->
      <el-form :inline="true" :model="conditions" class="search-form">
        <el-form-item :label="$t('carMonthCardConfig.search.cardName')">
          <el-input v-model="conditions.cardName" clearable style="width: 180px"
            @keyup.enter.native="search()" />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search()">{{ $t('common.search') }}</el-button>
          <el-button @click="resetConditions()">{{ $t('common.reset') }}</el-button>
        </el-form-item>
      </el-form>

      <!-- 月卡列表 -->
      <el-table :data="cardConfigs" border style="width: 100%" v-loading="loading">
        <el-table-column prop="cardName" :label="$t('carMonthCardConfig.table.cardName')" min-width="160"
          show-overflow-tooltip />
        <el-table-column prop="cardMonth" :label="$t('carMonthCardConfig.table.cardMonth')" align="center" width="120" />
        <el-table-column prop="cardPrice" :label="$t('carMonthCardConfig.table.cardPrice')" align="center" width="140" />
        <el-table-column prop="sortNo" :label="$t('carMonthCardConfig.table.sortNo')" align="center" width="100" />
        <el-table-column :label="$t('carMonthCardConfig.table.operation')" align="center" width="160" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" @click="showEditDialog(scope.row)">
              {{ $t('carMonthCardConfig.buttons.edit') }}
            </el-button>
            <el-button type="text" class="danger-text" @click="deleteConfig(scope.row)">
              {{ $t('carMonthCardConfig.buttons.delete') }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination class="pagination" :current-page.sync="page.current" :page-sizes="[10, 20, 30, 50]"
        :page-size="page.size" :total="page.total" layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
    </el-card>

    <!-- 新增 / 修改 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="520px" append-to-body>
      <el-form ref="form" :model="form" :rules="rules" label-width="110px" size="small">
        <el-form-item :label="$t('carMonthCardConfig.form.cardName')" prop="cardName">
          <el-input v-model="form.cardName" maxlength="50" :placeholder="$t('carMonthCardConfig.placeholders.cardName')" />
        </el-form-item>
        <el-form-item :label="$t('carMonthCardConfig.form.cardMonth')" prop="cardMonth">
          <el-input-number v-model="form.cardMonth" :min="1" :max="120" controls-position="right" />
        </el-form-item>
        <el-form-item :label="$t('carMonthCardConfig.form.cardPrice')" prop="cardPrice">
          <el-input v-model="form.cardPrice" :placeholder="$t('carMonthCardConfig.placeholders.cardPrice')" />
        </el-form-item>
        <el-form-item :label="$t('carMonthCardConfig.form.sortNo')" prop="sortNo">
          <el-input-number v-model="form.sortNo" :min="0" :max="9999" controls-position="right" />
        </el-form-item>
        <el-form-item :label="$t('carMonthCardConfig.form.remark')" prop="remark">
          <el-input v-model="form.remark" type="textarea" :rows="2" maxlength="200"
            :placeholder="$t('carMonthCardConfig.placeholders.remark')" />
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">{{ $t('carMonthCardConfig.buttons.cancel') }}</el-button>
        <el-button type="primary" :loading="saving" @click="submitForm()">
          {{ $t('carMonthCardConfig.buttons.confirm') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import {
  listCarMonthCardConfigs,
  saveCarMonthCardConfig,
  updateCarMonthCardConfig,
  deleteCarMonthCardConfig
} from '@/api/fee/carMonthCardConfigApi'

export default {
  name: 'CarMonthCardConfigList',
  data() {
    return {
      communityId: '',
      loading: false,
      saving: false,
      cardConfigs: [],
      conditions: {
        cardName: ''
      },
      page: {
        current: 1,
        size: 10,
        total: 0
      },
      dialogVisible: false,
      isEdit: false,
      form: {
        cardId: '',
        cardName: '',
        cardMonth: 1,
        cardPrice: '',
        sortNo: 0,
        remark: ''
      },
      rules: {
        cardName: [{ required: true, message: this.$t('carMonthCardConfig.rules.cardNameRequired'), trigger: 'blur' }],
        cardMonth: [{ required: true, message: this.$t('carMonthCardConfig.rules.cardMonthRequired'), trigger: 'change' }],
        cardPrice: [{ required: true, message: this.$t('carMonthCardConfig.rules.cardPriceRequired'), trigger: 'blur' }]
      }
    }
  },
  computed: {
    dialogTitle() {
      return this.isEdit ? this.$t('carMonthCardConfig.edit') : this.$t('carMonthCardConfig.add')
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._listCardConfigs()
  },
  methods: {
    async _listCardConfigs() {
      this.loading = true
      try {
        const params = {
          page: this.page.current,
          row: this.page.size,
          communityId: this.communityId,
          cardName: this.conditions.cardName,
          statusCd: '0'
        }
        const { data, total } = await listCarMonthCardConfigs(params)
        this.cardConfigs = data
        this.page.total = total
      } catch (error) {
        console.error('查询月卡配置失败:', error)
        this.$message.error(this.$t('carMonthCardConfig.errors.listFailed'))
      } finally {
        this.loading = false
      }
    },
    search() {
      this.page.current = 1
      this._listCardConfigs()
    },
    resetConditions() {
      this.conditions.cardName = ''
      this.search()
    },
    handleSizeChange(val) {
      this.page.size = val
      this.page.current = 1
      this._listCardConfigs()
    },
    handleCurrentChange(val) {
      this.page.current = val
      this._listCardConfigs()
    },
    showAddDialog() {
      this.isEdit = false
      this.form = {
        cardId: '',
        cardName: '',
        cardMonth: 1,
        cardPrice: '',
        sortNo: this.cardConfigs.length + 1,
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    showEditDialog(row) {
      this.isEdit = true
      this.form = {
        cardId: row.cardId,
        cardName: row.cardName,
        cardMonth: row.cardMonth,
        cardPrice: String(row.cardPrice),
        sortNo: row.sortNo,
        remark: ''
      }
      this.dialogVisible = true
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate()
        }
      })
    },
    submitForm() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          return
        }
        this.saving = true
        const params = {
          communityId: this.communityId,
          cardName: this.form.cardName,
          cardMonth: this.form.cardMonth,
          cardPrice: this.form.cardPrice,
          sortNo: this.form.sortNo,
          remark: this.form.remark
        }
        const request = this.isEdit
          ? updateCarMonthCardConfig({ ...params, configId: this.form.cardId })
          : saveCarMonthCardConfig(params)
        request.then(() => {
          this.$message.success(this.$t('common.operationSuccess'))
          this.dialogVisible = false
          this._listCardConfigs()
        }).catch(error => {
          console.error('保存月卡配置失败:', error)
          this.$message.error(error.message || this.$t('carMonthCardConfig.errors.saveFailed'))
        }).finally(() => {
          this.saving = false
        })
      })
    },
    deleteConfig(row) {
      this.$confirm(this.$t('carMonthCardConfig.buttons.delete') + ' ' + row.cardName + ' ?', '提示', {
        type: 'warning'
      }).then(() => {
        return deleteCarMonthCardConfig({
          communityId: this.communityId,
          configId: row.cardId
        })
      }).then(() => {
        this.$message.success(this.$t('common.operationSuccess'))
        this._listCardConfigs()
      }).catch(error => {
        if (error === 'cancel' || error === 'close') {
          return
        }
        console.error('删除月卡配置失败:', error)
        this.$message.error(error.message || this.$t('carMonthCardConfig.errors.deleteFailed'))
      })
    }
  }
}
</script>

<style scoped>
.car-month-card-config-container {
  padding: 16px;
}

.search-form {
  margin-top: 12px;
  margin-bottom: 4px;
}

.pagination {
  margin-top: 16px;
  text-align: right;
}

.danger-text {
  color: #f56c6c;
}
</style>
